import React from 'react';
import { Helmet } from 'react-helmet';

import { About, Footer, Header, Research, Skills, Testimonial, Work } from './container';
import { ExperienceLayer, Navbar } from './components';
import Education from './container/Education/Education';
import './App.scss';

const App = () => (
  <div className="app">
    <Helmet>
      <title>knowaminul — Software Developer &amp; Computer Vision Researcher</title>
      <meta
        name="description"
        content="The portfolio of knowaminul—software developer and computer vision researcher. Explore production software, peer-reviewed publications, research, and experience."
      />
      <meta name="theme-color" content="#171714" />
    </Helmet>
    <ExperienceLayer />
    <a className="skip-link" href="#main-content">Skip to content</a>
    <Navbar />
    <main id="main-content">
      <Header />
      <About />
      <Work />
      <Research />
      <Education />
      <Skills />
      <Testimonial />
      <Footer />
    </main>
  </div>
);

export default App;
